import { createContext, useContext, useEffect, useState } from "react";
import api from "../api/client.js";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("ccmc_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  // Revalidate the stored session on first load.
  useEffect(() => {
    const token = localStorage.getItem("ccmc_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me/")
      .then((res) => {
        setUser(res.data);
        localStorage.setItem("ccmc_user", JSON.stringify(res.data));
      })
      .catch(() => {
        localStorage.removeItem("ccmc_token");
        localStorage.removeItem("ccmc_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (mobile, password) => {
    const res = await api.post("/auth/login/", { mobile, password });
    localStorage.setItem("ccmc_token", res.data.token);
    localStorage.setItem("ccmc_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  // Replace the cached user (e.g. after a password change clears the
  // must_change_password flag) without a fresh login round-trip.
  const updateUser = (next) => {
    setUser(next);
    localStorage.setItem("ccmc_user", JSON.stringify(next));
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout/");
    } catch {
      /* ignore network errors on logout */
    }
    localStorage.removeItem("ccmc_token");
    localStorage.removeItem("ccmc_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
